import { render, staticRenderFns } from "./RepaletizajeForm.vue?vue&type=template&id=6a18644a"
import script from "./RepaletizajeForm.vue?vue&type=script&lang=js"
export * from "./RepaletizajeForm.vue?vue&type=script&lang=js"
import style0 from "./RepaletizajeForm.vue?vue&type=style&index=0&id=6a18644a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports